import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card } from 'react-bootstrap';
import { supplierModification, getSingleSupplier } from "./supplierAction";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight, faRightToBracket, faUpload, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { useParams,useNavigate, Link } from 'react-router-dom';
import { FaEdit, FaTrash, FaPlus, FaArrowLeft } from 'react-icons/fa';

import Swal from 'sweetalert2';

const ModifySupplier = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const {id}=useParams();
  const SupplierRef = useRef(null);
  const [alertStatus, setAlertStatus] = useState('');
  const [mobileNoError, setMobileNoError] = useState(false);
  const [emailError ,setEmailError] = useState(false);
  const [nameError ,setNameError] = useState(false);
  const [contactPError ,setContactPError] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm();
 
  const { supiscLoading, supmstatus, supmmessage} = useSelector((state) => state.supplierList);
  const supplierData = useSelector((state) => state.supplierList);
 const uData = JSON.parse(JSON.stringify(supplierData.supSDetails));

  const initialState = {
    id:"",
    suppliername:"",
    mobile:"",
    email:"",
    contactperson:"",
    addressone:"",
    addresstwo:"",
    status:"",
    password:"",
  }

  const [modify, setModify] = useState(0);
  const [suppliers, setSuppliers ] = useState(initialState);

 
  
  const firstUpdate = useRef(true);
  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      loadSupplier(id);
      return;
    } 
  });
  
 
  useEffect(() => { 
   
    loadSupplier(id);
    setSuppliers({id:id,suppliername:"",mobile:"",email:"",contactperson:"",addressone:"",addresstwo:"",status:""});
     }, []);

  
     
    
    function loadSupplier(id) {
      dispatch(getSingleSupplier(id));
      setSuppliers({id:id,suppliername:uData.supplier_name,mobile:uData.mobile_no,email:uData.email_id,contactperson:uData.contact_person,addressone:uData.address1,addresstwo:uData.address2,status:uData.status});
      
    }

    const handleOnChange = e => {
      const name = e.target.name;
      const value = e.target.value;
     
      setSuppliers({ ...suppliers, [name]: value });

      if (name === "mobile") {
        if (!/^\d+$/.test(value) || (value.length < 10 || value.length >= 15)) {
          setMobileNoError('Enter a valid mobile number');
        } else {
          setMobileNoError('');
        }
      }
      if (name === "email") {
        if (!value.includes('@')) {
          setEmailError('Enter valid email');
        } else {
          setEmailError('');
        }
      }
      if (name === "suppliername") {
        if (!/^[a-zA-Z]+$/.test(value)) {
          setNameError('Enter valid supplier name');
        } else {
          setNameError('');
        }
      }
      if (name === "contactperson") {
        if (!/^[a-zA-Z]+$/.test(value)) {
          setContactPError('Enter valid name');
        } else {
          setContactPError('');
        }
      }
    
    };

    const isDisabled = mobileNoError || emailError || nameError || contactPError;
    
    
    const handleOnSubmit = (e) => {
      e.preventDefault();
    
      const { id, suppliername, mobile, email, contactperson, addressone, addresstwo,password,status } = suppliers;
      // Compare modified values with initial values
      if (
        suppliername !== "" ||
        mobile !==  "" ||
        email !==  "" ||
        contactperson !==  "" ||
        addressone !==  "" ||
        addresstwo !==  "" ||
        password !== undefined     ||
        status !==  ""
      ) {
        const supplierUpdation = { id, suppliername, mobile, email, contactperson, addressone, addresstwo, status };
        dispatch(supplierModification(supplierUpdation));
        setModify(1);
        navigate('/supplierLists');
        Swal.fire('Supplier updated Successfully!', '', 'success');
      } else {
        Swal.fire('No changes made!', '', 'warning');
      }
    };
    
    

  return (
    <>
            <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-50px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Modify Supplier</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                          <Col>
                            <Link to="/supplierLists"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
                            </Col>
                        </Row>
                        <br />
            <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit(e))}> {/* handleOnSubmit() */}

              <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridSupplierName">
                  <Form.Label>Supplier Name</Form.Label>
                  <Form.Control type="text" ref={SupplierRef}  name="suppliername" value={suppliers.suppliername ? suppliers.suppliername : uData.supplier_name} required="true" autoComplete='off' placeholder="Enter Supplier Name" {...register("suppliername", { required: true, mixLength: 3 })} maxLength={50}  onChange={handleOnChange}/>
                  {errors.suppliername && <p className='text-danger'> Supplier Name required</p>}
                  {nameError && <p className='text-danger'>Enter valid supplier name</p>}

                </Form.Group>
               
                <Form.Group as={Col} controlId="formGridMobile">
                  <Form.Label>Mobile No</Form.Label>
                  <Form.Control type="text" ref={SupplierRef}  name="mobile" value={suppliers.mobile ? suppliers.mobile : uData.mobile_no} required="true" autoComplete='off' placeholder="Enter Mobile No" {...register("mobile", { required: true, mixLength: 3 })} onChange={handleOnChange}/>
                  {errors.mobile && <p className='text-danger'> Mobile No required</p>}
                  {mobileNoError && <p className="text-danger">{mobileNoError}</p>}
                </Form.Group>
               
                </Row>
               

                <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridEmail">
                  <Form.Label>Email Id</Form.Label>
                  <Form.Control type="text" ref={SupplierRef} maxLength={40} name="email" value={suppliers.email ? suppliers.email : uData.email_id} required="true" autoComplete='off' placeholder="Enter Email" {...register("email", { required: true, mixLength: 3 })} onChange={handleOnChange}/>
                  {errors.email && <p className='text-danger'> Email Id required</p>}
                  {emailError && <p className='text-danger'> Enter valid email address</p>}
                </Form.Group>
               
                <Form.Group as={Col} controlId="formGridPassword">
                  <Form.Label>Change Password</Form.Label>
                  <Form.Control type="password" ref={SupplierRef}  name="password"  required="true" autoComplete='off' placeholder="Enter Pasword" {...register("password", { required: true, mixLength: 3 })} onChange={handleOnChange}/>
                  {errors.password && <p className='text-danger'> Password required</p>}
                </Form.Group>
                </Row>

                <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridAddress1">
                  <Form.Label>Address 1</Form.Label>
                  <Form.Control type="text" ref={SupplierRef} maxLength={100}  name="addressone" value={suppliers.addressone ? suppliers.addressone : uData.address1} required="true" autoComplete='off' placeholder="Enter Address1" {...register("addressone", { required: true, mixLength: 3 })} onChange={handleOnChange}/>
                  {errors.addressone && <p className='text-danger'> Address1 required</p>}
                </Form.Group>
               
                <Form.Group as={Col} controlId="formGridAddress2">
                  <Form.Label>Address 2</Form.Label>
                  <Form.Control type="text" ref={SupplierRef} maxLength={100}  name="addresstwo" value={suppliers.addresstwo ? suppliers.addresstwo : uData.address2} required="true" autoComplete='off' placeholder="Enter Address2" {...register("addresstwo", { required: true, mixLength: 3 })} onChange={handleOnChange}/>
                  {errors.addresstwo && <p className='text-danger'> Address2 required</p>}
                </Form.Group>
                </Row>
                <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridContactPerson">
                  <Form.Label>Contact Person</Form.Label>
                  <Form.Control type="text" ref={SupplierRef}  name="contactperson" value={suppliers.contactperson ? suppliers.contactperson : uData.contact_person} required="true" autoComplete='off' placeholder="Enter Contact Person" {...register("contactperson", { required: true, mixLength: 3 })} onChange={handleOnChange}/>
                  {errors.contactperson && <p className='text-danger'> Contact Person required</p>}
                  {contactPError && <p className='text-danger'> Enater valid name</p>}
                </Form.Group>
                <Form.Group as={Col} controlId="formGridStatus">
                  <Form.Label>Status</Form.Label>
                  <Form.Select required name="status" value={suppliers.status ? suppliers.status : uData.status} onChange={handleOnChange}>
                    
                    <option value="">Choose..</option>
                    <option value="1">Enable</option>
                    <option value="0">Disable</option>
                  </Form.Select>
                  {errors.status && <p className='text-danger'>Status required</p>}
                </Form.Group>
              </Row>
              <div class="d-grid  col-2 mx-auto">
              <Button variant="primary" type="submit" className='align-middle' disabled={isDisabled} >
              <FontAwesomeIcon icon={faRightToBracket} /> Submit
              </Button>
              </div>
              {supiscLoading && (<Spinner variant='info' animation='border' />)}

            </Form>
            </div>
            </div>
            </div>
          
    </>
  );
}

export default ModifySupplier;